export function fmtInr(v, digits = 2) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  const opts = { minimumFractionDigits: digits, maximumFractionDigits: digits };
  return `\u20B9${n.toLocaleString("en-IN", opts)}`;
}

export function fmtNum(v, digits = 2) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toLocaleString("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtPct(v) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  const sign = n >= 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}

export function pnlClass(v) {
  if (v === null || v === undefined || isNaN(v)) return "";
  return Number(v) >= 0 ? "profit" : "loss";
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
